import instance from "../axios/axios";

// Fetch all patients with pagination and search
export const getPatients = async ({ page, limit, search }) => {
    try {
        const response = await instance.get(`/api/patient/patients?page=${page}&limit=${limit}&search=${search}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Fetch patients for dropdown
export const fetchPatientsForDropdown = async () => {
    try {
      const response = await instance.get("/api/patient/patients/dropdown");
      return response.data.data;
    } catch (error) {
      console.error("Failed to fetch patients", error);
      return [];
    }
  };

// Fetch a single patient by ID
export const getPatientById = async (id) => {
    try {
        const response = await instance.get(`/api/patient/patients/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Create a new patient
export const createPatient = async (patientData) => {
    try {
        const response = await instance.post(`/api/patient/patients`, patientData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Update an existing patient
export const updatePatient = async (id, patientData) => {
    try {
        const response = await instance.put(`/api/patient/patients/${id}`, patientData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};

// Delete a patient
export const deletePatient = async (id) => {
    try {
        const response = await instance.delete(`/api/patient/patients/${id}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error; 
    }
};